/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { unitMesurementdetailsHead } from "../../../../../config/constant";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Row, Col, Image, Space } from "antd";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Button, TextField, Box, TableRow, TableCell } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import clsx from "clsx";
import { toast } from 'react-toastify';
import { emptyValidation, customAlaphaNumericOnlyValidation, customDecimalValidation } from "../../../../../helpers/validation";
import { NavLink } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';

export const UnitMeasurementTable = (props) => {
    const { details, unitClassdetails, handleUnitClassId, rowClick, onRequestSort, loadMoreContent, sortOrder, sortBy, loadMore, loadMoreTask, roleManagement } = props;
    const [visible, setVisible] = useState(false);
    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [unitId, setUnitId] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [classId, setClassId] = useState('');
    const [systemOfUnits, setSystemOfUnits] = useState('');
    const [precision, setPrecision] = useState('');
    const prevEditDetails = usePrevious(editDetails);
    const [errorClass, setErrorClass] = useState(false);
    const [errorPrecision, setErrorPrecision] = useState(false);
    const prevEditError = usePrevious(editError);
    const [errorName, setErrorName] = useState(false);
    //const [errorDescription, setErrorDescription] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedID, setSelectedID] = useState(false);

    const dispatch = useDispatch();

    const onEdit = (data) => {
        setVisible(true);
        setUnitId(data.id);
        setName(data.name);
        setDescription(data.description);
        setSystemOfUnits(data.systemOfUnits);
        setPrecision(data.precision > 0 ? data.precision : '');
        setClassId(data.unitClassId);
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setUnitId(data.id);
        setName(data.name);
    }

    const emptyState = () => {
        setErrorName(false);
        setErrorClass(false);
        setErrorPrecision(false);
    };

    const editMeasurement = (e) => {
        e.preventDefault();
        let emptyName = customAlaphaNumericOnlyValidation('Unit', name);
        let emptyClass = emptyValidation('Unit Class', classId, 'dropDown');
        let emptyDescimal = customDecimalValidation('Decimal Precision', precision);
        emptyState();
        if (emptyName.isValid && emptyClass.isValid && emptyDescimal.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: 'unit',
                id: unitId,
                title: 'Unit',
                details: {
                    name: name,
                    description: description,
                    unitClassId: classId,
                    systemOfUnits: systemOfUnits,
                    precision: precision ? parseInt(precision) : 0
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyClass.errors) {
                setErrorClass(emptyClass.errors);
            }
            if (emptyDescimal.errors) {
                setErrorPrecision(emptyDescimal.errors);
            }

        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            handleUnitClassId('');
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'name') {
                setErrorName(error[1]);
            }
        }
    }, [editDetails, editError]);

    const handleRowClick = (value) => {
        setSelectedID(value);
        rowClick(value);
    }

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                heads={unitMesurementdetailsHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                loadMoreContent={loadMoreContent}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} onClick={() => { handleRowClick(data.id) }}
                                                selected={selectedID === data.id}
                                                classes={{ selected: classes.selected }} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(unitMesurementdetailsHead, 0) }}><span style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }}>{data?.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }}><span style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }} className={classes.descEllipsis}>{data?.description ? data?.description : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(unitMesurementdetailsHead, 2) }}><span style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }}>{data?.unitClass?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(unitMesurementdetailsHead, 3) }}><span style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }}>{data?.systemOfUnits ? data?.systemOfUnits : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(unitMesurementdetailsHead, 4) }}><span style={{ width: getColumnWidth(unitMesurementdetailsHead, 1) }}>{data.precision ? data?.precision : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Unit of Measurement', 'edit', 'Younote Admin') || checkCRUDPermission('Unit of Measurement', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    onClick={() => onEdit(data)}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Unit of Measurement', 'deletable', 'Younote Admin') || checkCRUDPermission('Unit of Measurement', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>
                                                        {'If no Unit Conversion are Listed here. Please Contact Younote Admin'}
                                                    </p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Unit'}
                width={"360px"}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editMeasurement(e)}
                    >
                        <Row gutter={40}>
                            <Col span={12}>
                                <TextField autoComplete='one-time-code'
                                    label={["Unit ", <span key={'Unit'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    value={name}
                                    fullWidth
                                    error={errorName ? true : false}
                                    helperText={errorName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </Col>
                            <Col span={12}>
                                <AutoCompleteComponent
                                    name={["Unit Class ", <span key={'Unit Class'} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                    details={unitClassdetails}
                                    parentValue={customObject(unitClassdetails, classId)}
                                    onChange={(data) => setClassId(data.id)}
                                    position={"bottom"}
                                    parentError={errorClass}
                                />
                            </Col>
                            <Col span={12}>
                                <TextField autoComplete='one-time-code'
                                    type="number"
                                    label='Decimal Precision'
                                    error={errorPrecision && true}
                                    helperText={errorPrecision}
                                    variant={'standard'}
                                    value={precision}
                                    fullWidth
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setPrecision(e.target.value)}
                                />
                            </Col>
                            <Col span={12}>
                                <TextField autoComplete='one-time-code'
                                    label='Description'
                                    variant={'standard'}
                                    fullWidth
                                    value={description}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                            </Col>
                            {/* <Col span={12}>
                                <TextField autoComplete='one-time-code'
                                    label='System of Units'
                                    variant={'standard'}
                                    fullWidth
                                    value={systemOfUnits}
                                    className={clsx(classes.margin30t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setSystemOfUnits(e.target.value)}
                                />
                            </Col> */}
                            <Col span={12}>
                                <AutoCompleteComponent
                                    name={["System of Units"]}
                                    heads={[{ 'key': 'label', 'name': 'Label' }]}
                                    details={[{ label: 'Metric system', id: 'Metric system' }, { label: 'Imperial system', id: 'Imperial system' }]}
                                    parentValue={customObject([{ label: 'Metric system', id: 'Metric system' }, { label: 'Imperial system', id: 'Imperial system' }], systemOfUnits)}
                                    onChange={(data) => setSystemOfUnits(data.id)}
                                    position={"bottom"}
                                    customClasses={classes.margin20t}
                                />
                            </Col>
                        </Row>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update & Close
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={unitId} loadTasks={() => handleUnitClassId()} name={name} url={'unit'} title={'Unit'} visible={deleteModal} />
        </>
    )
}